import { BBDTag, GraviButton, Horizontal, MaterialIcon, Texto } from '@gravitate-js/excalibrr'
import React from 'react'

import type { CreditRebillResponse, Invoice } from '../../../../../api/useFreight/types'

interface RebillFooterProps {
  isSavingRebill: boolean
  handleSaveRebill: () => void
  rebillInvoice: Invoice
  setIsRebillMode: (mode: boolean) => void
  rebillMetadata: CreditRebillResponse
}

/**
 * Footer component displayed when in rebill mode
 * Shows rebill statistics and action buttons
 */
export function RebillFooter({
  isSavingRebill,
  handleSaveRebill,
  rebillInvoice,
  setIsRebillMode,
  rebillMetadata,
}: RebillFooterProps) {
  const orderDiff = rebillMetadata.order_count
  const addedLineItems = rebillMetadata.added_line_items
  const removedLineItems = rebillMetadata.removed_line_items
  const impactedLineItems = rebillMetadata.impacted_line_items

  const handleCancel = () => {
    setIsRebillMode(false)
  }

  return (
    <Horizontal
      style={{
        borderTop: '1px solid var(--gray-200)',
        backgroundColor: 'var(--bg-1)',
      }}
      verticalCenter
    >
      <Horizontal
        style={{
          backgroundColor: 'var(--theme-warning)',
          borderRight: '1px solid var(--gray-200)',
        }}
        className='px-5 py-4'
        verticalCenter
      >
        <Texto weight='bold' appearance='white' category='h5'>
          INVOICE CREDIT/REBILL
        </Texto>
      </Horizontal>

      <Horizontal flex={1} gap={24} style={{ padding: '8px 16px' }}>
        {orderDiff !== 0 && (
          <Horizontal gap={8} verticalCenter>
            <Texto>Impacted Orders:</Texto>
            <BBDTag>
              <span style={{ fontWeight: 'bold' }}>{rebillInvoice?.order_count || 0}</span>
            </BBDTag>
          </Horizontal>
        )}
        <Horizontal gap={8} verticalCenter>
          <Texto>Line Items:</Texto>
          {addedLineItems > 0 && (
            <BBDTag style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <MaterialIcon icon='list_alt_add' />
              {addedLineItems}
            </BBDTag>
          )}
          {removedLineItems > 0 && (
            <BBDTag style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <MaterialIcon icon='remove' />
              {removedLineItems}
            </BBDTag>
          )}
          {impactedLineItems > 0 && (
            <BBDTag style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <MaterialIcon icon='sync_alt' />
              {impactedLineItems}
            </BBDTag>
          )}
        </Horizontal>
      </Horizontal>
      <Horizontal gap={8} style={{ padding: '8px 16px' }}>
        <GraviButton buttonText='Cancel' onClick={handleCancel} />
        <GraviButton loading={isSavingRebill} buttonText='Confirm Changes' color='primary' onClick={handleSaveRebill} />
      </Horizontal>
    </Horizontal>
  )
}
